import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue";
import { IconEnum } from "@/modules/vue/enums";
import { Icon as IconWrapper } from '@vicons/utils';
import GlobeEurope from '@vicons/fa/GlobeEurope';
import SoccerField from '@vicons/tabler/SoccerField';
import World from '@vicons/tabler/World';
import Crown from '@vicons/tabler/Crown';
import DeviceTv from '@vicons/tabler/DeviceTv';
import Bulldozer from '@vicons/tabler/Bulldozer';
import Crane from '@vicons/tabler/Crane';
import ScoreboardOutlined from '@vicons/material/ScoreboardOutlined';
import FormatListNumberedOutlined from '@vicons/material/FormatListNumberedOutlined';
import Binoculars from '@vicons/carbon/Binoculars';
import ArrowsHorizontal from '@vicons/carbon/ArrowsHorizontal';
import EuroFilled from '@vicons/material/EuroFilled';
import SportsFilled from '@vicons/material/SportsFilled';
import SortOutlined from '@vicons/material/SortOutlined';
import FilterAltOutlined from '@vicons/material/FilterAltOutlined';
import PersonSearchOutlined from '@vicons/material/PersonSearchOutlined';
import ChevronLeftFilled from '@vicons/material/ChevronLeftFilled';
import ChevronRightFilled from '@vicons/material/ChevronRightFilled';
import CheckRound from '@vicons/material/CheckRound';
import ConstructionOutlined from '@vicons/material/ConstructionOutlined';
import StadiumOutlined from '@vicons/material/StadiumOutlined';
import ClockRegular from '@vicons/fa/ClockRegular';
import Star16Regular from '@vicons/fluent/Star16Regular';
import Star16Filled from '@vicons/fluent/Star16Filled';
import StarHalf24Filled from '@vicons/fluent/StarHalf24Filled';
import StarEmphasis20Regular from '@vicons/fluent/StarEmphasis20Regular';
import StarEmphasis32Regular from '@vicons/fluent/StarEmphasis32Regular';
import StarEmphasis32Filled from '@vicons/fluent/StarEmphasis32Filled';
import ErrorCircle16Regular from '@vicons/fluent/ErrorCircle16Regular';
import QuestionCircle32Regular from '@vicons/fluent/QuestionCircle32Regular';
import LockOpen24Regular from '@vicons/fluent/LockOpen24Regular';
import LockClosed24Regular from '@vicons/fluent/LockClosed24Regular';
import Trophy24Regular from '@vicons/fluent/Trophy24Regular';
import Dumbbell28Regular from '@vicons/fluent/Dumbbell28Regular';
import Handshake20Regular from '@vicons/fluent/Handshake20Regular';
import ClipboardSettings20Regular from '@vicons/fluent/ClipboardSettings20Regular';
import BuildingMultiple20Regular from '@vicons/fluent/BuildingMultiple20Regular';
import PeopleCommunity20Regular from '@vicons/fluent/PeopleCommunity20Regular';
import People20Regular from '@vicons/fluent/People20Regular';
import Battery120Regular from '@vicons/fluent/Battery120Regular';
import Battery320Regular from '@vicons/fluent/Battery320Regular';
import Battery520Regular from '@vicons/fluent/Battery520Regular';
import Battery720Regular from '@vicons/fluent/Battery720Regular';
import Battery920Regular from '@vicons/fluent/Battery920Regular';
import Reward20Regular from '@vicons/fluent/Reward20Regular';
import Save16Regular from '@vicons/fluent/Save16Regular';
import DocumentBulletListOff20Regular from '@vicons/fluent/DocumentBulletListOff20Regular';
import SignOut24Regular from '@vicons/fluent/SignOut24Regular';
import Signature20Regular from '@vicons/fluent/Signature20Regular';
import MegaphoneLoud20Regular from '@vicons/fluent/MegaphoneLoud20Regular';
import ChartMultiple20Regular from '@vicons/fluent/ChartMultiple20Regular';
import ChartPerson20Regular from '@vicons/fluent/ChartPerson20Regular';
import ArrowLeft32Filled from '@vicons/fluent/ArrowLeft32Filled';
import ArrowRight32Filled from '@vicons/fluent/ArrowRight32Filled';
import PeopleAudience20Regular from '@vicons/fluent/PeopleAudience20Regular';
import Add20Regular from '@vicons/fluent/Add20Regular';
import Subtract20Regular from '@vicons/fluent/Subtract20Regular';
import Pause20Regular from '@vicons/fluent/Pause20Regular';
import AlertOn20Regular from '@vicons/fluent/AlertOn20Regular';
import AlertOff20Regular from '@vicons/fluent/AlertOff20Regular';
import FastForward20Regular from '@vicons/fluent/FastForward20Regular';
import Play20Regular from '@vicons/fluent/Play20Regular';
import Money20Regular from '@vicons/fluent/Money20Regular';
import MoneyDismiss20Regular from '@vicons/fluent/MoneyDismiss20Regular';
import IosTimer from '@vicons/ionicons4/IosTimer';
import IosSearch from '@vicons/ionicons4/IosSearch';
import IosCog from '@vicons/ionicons4/IosCog';
import CloseOutline from '@vicons/ionicons5/CloseOutline';
import CheckmarkDone from '@vicons/ionicons5/CheckmarkDone';
import NotificationsOutline from '@vicons/ionicons5/NotificationsOutline';
import Notifications from '@vicons/ionicons5/Notifications';
import Menu from '@vicons/ionicons5/Menu';
import EyeOutline from '@vicons/ionicons5/EyeOutline';
import Dumbbell from '@vicons/fa/Dumbbell';
import Coins from '@vicons/fa/Coins';
import FlagCheckered from '@vicons/fa/FlagCheckered';
import Play from '@vicons/fa/Play';
import PlayCircle from '@vicons/fa/PlayCircle';
import PauseCircle from '@vicons/fa/PauseCircle';
import InteractionOutlined from '@vicons/antd/InteractionOutlined';
import ArrowLeft from '@vicons/fa/ArrowLeft';
import ArrowRight from '@vicons/fa/ArrowRight';
import AngleDown from '@vicons/fa/AngleDown';
import AngleUp from '@vicons/fa/AngleUp';
import MoneyBillAltRegular from '@vicons/fa/MoneyBillAltRegular';
import Ban from '@vicons/fa/Ban';
import Futbol from '@vicons/fa/Futbol';
import DotCircleRegular from '@vicons/fa/DotCircleRegular';
import CaretSquareRightRegular from '@vicons/fa/CaretSquareRightRegular';
export default /*#__PURE__*/_defineComponent({
  __name: 'Icon',
  props: {
    icon: null,
    size: {
      default: '1.5rem'
    }
  },
  setup(__props) {
    const props = __props;
    const iconComponent = computed(() => {
      return {
        [IconEnum.GlobeEurope]: GlobeEurope,
        [IconEnum.SoccerField]: SoccerField,
        [IconEnum.ScoreboardOutlined]: ScoreboardOutlined,
        [IconEnum.World]: World,
        [IconEnum.FormatListNumberedOutlined]: FormatListNumberedOutlined,
        [IconEnum.Binoculars]: Binoculars,
        [IconEnum.Handshake20Regular]: Handshake20Regular,
        [IconEnum.EuroFilled]: EuroFilled,
        [IconEnum.ClockRegular]: ClockRegular,
        [IconEnum.Star16Regular]: Star16Regular,
        [IconEnum.Star16Filled]: Star16Filled,
        [IconEnum.StarHalf24Filled]: StarHalf24Filled,
        [IconEnum.StarEmphasis20Regular]: StarEmphasis20Regular,
        [IconEnum.StarEmphasis32Regular]: StarEmphasis32Regular,
        [IconEnum.StarEmphasis32Filled]: StarEmphasis32Filled,
        [IconEnum.Dumbbell]: Dumbbell,
        [IconEnum.Coins]: Coins,
        [IconEnum.ArrowsHorizontal]: ArrowsHorizontal,
        [IconEnum.ConstructionOutlined]: ConstructionOutlined,
        [IconEnum.FlagCheckered]: FlagCheckered,
        [IconEnum.Play]: Play,
        [IconEnum.PlayCircle]: PlayCircle,
        [IconEnum.PauseCircle]: PauseCircle,
        [IconEnum.ErrorCircle16Regular]: ErrorCircle16Regular,
        [IconEnum.Futbol]: Futbol,
        [IconEnum.Whistle]: SportsFilled,
        [IconEnum.InteractionOutlined]: InteractionOutlined,
        [IconEnum.ArrowLeft]: ArrowLeft,
        [IconEnum.ArrowRight]: ArrowRight,
        [IconEnum.IosCog]: IosCog,
        [IconEnum.AngleDown]: AngleDown,
        [IconEnum.AngleUp]: AngleUp,
        [IconEnum.SortOutlined]: SortOutlined,
        [IconEnum.FilterAltOutlined]: FilterAltOutlined,
        [IconEnum.PersonSearchOutlined]: PersonSearchOutlined,
        [IconEnum.ChevronLeftFilled]: ChevronLeftFilled,
        [IconEnum.ChevronRightFilled]: ChevronRightFilled,
        [IconEnum.MoneyBillAltRegular]: MoneyBillAltRegular,
        [IconEnum.Ban]: Ban,
        [IconEnum.Crown]: Crown,
        [IconEnum.CheckmarkDone]: CheckmarkDone,
        [IconEnum.CheckRound]: CheckRound,
        [IconEnum.QuestionCircle32Regular]: QuestionCircle32Regular,
        [IconEnum.CloseOutline]: CloseOutline,
        [IconEnum.NotificationsOutline]: NotificationsOutline,
        [IconEnum.Notifications]: Notifications,
        [IconEnum.Menu]: Menu,
        [IconEnum.DeviceTv]: DeviceTv,
        [IconEnum.LockOpen24Regular]: LockOpen24Regular,
        [IconEnum.LockClosed24Regular]: LockClosed24Regular,
        [IconEnum.IosTimer]: IosTimer,
        [IconEnum.Trophy24Regular]: Trophy24Regular,
        [IconEnum.DotCircleRegular]: DotCircleRegular,
        [IconEnum.SignOut24Regular]: SignOut24Regular,
        [IconEnum.Save16Regular]: Save16Regular,
        [IconEnum.StadiumOutlined]: StadiumOutlined,
        [IconEnum.Dumbbell28Regular]: Dumbbell28Regular,
        [IconEnum.IosSearch]: IosSearch,
        [IconEnum.PeopleCommunity20Regular]: PeopleCommunity20Regular,
        [IconEnum.People20Regular]: People20Regular,
        [IconEnum.ClipboardSettings20Regular]: ClipboardSettings20Regular,
        [IconEnum.BuildingMultiple20Regular]: BuildingMultiple20Regular,
        [IconEnum.Battery120Regular]: Battery120Regular,
        [IconEnum.Battery320Regular]: Battery320Regular,
        [IconEnum.Battery520Regular]: Battery520Regular,
        [IconEnum.Battery720Regular]: Battery720Regular,
        [IconEnum.Battery920Regular]: Battery920Regular,
        [IconEnum.CaretSquareRightRegular]: CaretSquareRightRegular,
        [IconEnum.EyeOutline]: EyeOutline,
        [IconEnum.Signature20Regular]: Signature20Regular,
        [IconEnum.DocumentBulletListOff20Regular]: DocumentBulletListOff20Regular,
        [IconEnum.ChartMultiple20Regular]: ChartMultiple20Regular,
        [IconEnum.MegaphoneLoud20Regular]: MegaphoneLoud20Regular,
        [IconEnum.ChartPerson20Regular]: ChartPerson20Regular,
        [IconEnum.ArrowLeft32Filled]: ArrowLeft32Filled,
        [IconEnum.ArrowRight32Filled]: ArrowRight32Filled,
        [IconEnum.PeopleAudience20Regular]: PeopleAudience20Regular,
        [IconEnum.Add20Regular]: Add20Regular,
        [IconEnum.Subtract20Regular]: Subtract20Regular,
        [IconEnum.Pause20Regular]: Pause20Regular,
        [IconEnum.AlertOn20Regular]: AlertOn20Regular,
        [IconEnum.AlertOff20Regular]: AlertOff20Regular,
        [IconEnum.FastForward20Regular]: FastForward20Regular,
        [IconEnum.Play20Regular]: Play20Regular,
        [IconEnum.Bulldozer]: Bulldozer,
        [IconEnum.Crane]: Crane,
        [IconEnum.Reward20Regular]: Reward20Regular,
        [IconEnum.Money20Regular]: Money20Regular,
        [IconEnum.MoneyDismiss20Regular]: MoneyDismiss20Regular
      }[props.icon];
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(IconWrapper), {
        size: __props.size
      }, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(_unref(iconComponent))))]),
        _: 1
      }, 8, ["size"]);
    };
  }
});